import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import type {
  ClearDataviewParams,
  DataviewGetRequest,
  DataviewKpiRequest,
  DataviewKpiResponse,
} from "./DataviewAPI.types";

export const dataviewAPI = createApi({
  reducerPath: "dataviewAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getDataviewKpis: builder.query<DataviewKpiResponse, DataviewGetRequest>({
      query: (params) => {
        const queryParams = new URLSearchParams({
          DataViewID: params.DataViewID,
          AffAbos: `${params.Aff}-${params.Abo}`,
          Period: params.Period,
          Locale: params.Locale,
          IsoCountryCode: params.IsoCountryCode,
        });
        return {
          url: `/abo-enrichment/api/enrich/dataview?${queryParams.toString()}`,
          method: "GET",
        };
      },
    }),
    updateDataviewKpis: builder.mutation<DataviewKpiResponse, DataviewKpiRequest>({
      query: (params) => ({
        url: `/abo-enrichment/api/dataview`,
        method: "POST",
        body: {
          DataViewId: params.dataviewId,
          Kpis: params.selectedKpis,
        },
      }),
    }),
    clearDataview: builder.mutation<void, ClearDataviewParams>({
      query: ({ DataViewID }) => ({
        url: `/abo-enrichment/api/dataview?${new URLSearchParams({ DataViewID })}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const { useGetDataviewKpisQuery, useUpdateDataviewKpisMutation, useClearDataviewMutation } = dataviewAPI;
